import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { tabsInjectionKey as a } from "./interface.js";
import { throwError as n, warnOnce as s } from "../../_utils/naive/warn.js";
import { defineComponent as r, watchEffect as i, inject as l, h as o } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const b = {
  tab: [String, Number, Object, Function],
  name: {
    type: [String, Number],
    required: !0
  },
  disabled: Boolean,
  displayDirective: {
    type: String,
    default: "if"
  },
  closable: {
    type: Boolean,
    default: void 0
  },
  tabProps: Object,
  /** @deprecated */
  label: [String, Number, Object, Function]
}, u = r({
  __TAB_PANE__: !0,
  name: "TabPane",
  alias: ["TabPanel"],
  props: b,
  slots: Object,
  setup(t) {
    process.env.NODE_ENV !== "production" && i(() => {
      t.label !== void 0 && s("tab-pane", "`label` is deprecated, please use `tab` instead.");
    });
    const e = l(a, null);
    return e || n("tab-pane", "`n-tab-pane` must be placed inside `n-tabs`."), {
      style: e.paneStyleRef,
      class: e.paneClassRef,
      mergedClsPrefix: e.mergedClsPrefixRef
    };
  },
  render() {
    return o("div", {
      class: [`${this.mergedClsPrefix}-tab-pane`, this.class],
      style: this.style
    }, this.$slots);
  }
});
export {
  u as default,
  b as tabPaneProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tabs/src/TabPane.js
// module id = 474
// module chunks = 41